import { Box, Button, Grid, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import SettelmentRequestListModal from "../../components/modals/SettelmentRequestListModal";
import SelectTable from "../../components/table/SelectTable";
import { SETTLEMENT_REQUEST_KEY } from "../../config/cacheKey";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import { GetEnumsResponse } from "../../models/enum.model";
import { PaginationInfo } from "../../models/security.model";
import {
  GetRegisteredSalesToApproveResponse,
  SettlementType,
  SettlemetRequestToApproveFilter,
} from "../../models/settlement.model";
import { AllStoresAndBranchesResponse } from "../../models/supplierUserBarnch.model";
import {
  getAllBranches,
  GetAllStoresAndBranches,
} from "../../services/dropdown.service";
import { getEnumsPersian } from "../../services/enum.services";
import {
  getRegisteredSalesToApprove,
  getRegisteredSalesToApproveReportExcel,
  registerSettlementRequest,
} from "../../services/settlement.service";
import SettlementRequestsListFilter from "./components/SettlementRequestsListFilter";
import SettlementRequestsListSkeleton from "./components/SettlementRequestsListSkeleton";

const columns: ColumnModel[] = [
  { id: "sellerName", label: "نام فروشنده" },
  { id: "customerFullName", label: "نام متقاضی" },
  { id: "customerNationalCode", label: "کد ملی متقاضی" },
  { id: "customerMobileNumber", label: "شماره موبایل" },
  { id: "saleDate_Persian", label: "تاریخ فروش" },
  {
    id: "creditAmount",
    label: " مبلغ فاکتور (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "settlementAmount",
    label: " مبلغ تسویه (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  { id: "waitForSettlementDate_Persian", label: "تاریخ آماده به تسویه" },
  { id: "settlementDeadlineDate_Persian", label: "مهلت تسویه" },
  { id: "saleType_Persian", label: "نوع فروش" },
  {
    id: "iban",
    label: "شماره شبا پذیرنده",
  },
  {
    id: "ibanOwner",
    label: "نام صاحب حساب",
  },
];

const SettelmentRequestsList = () => {
  useEffect(() => {
    queryClient.setQueryData<GetRegisteredSalesToApproveResponse[]>(
      SETTLEMENT_REQUEST_KEY,
      []
    );
  }, []);

  const [totalAmount, setTotalAmount] = useState(0);
  const [open, setOpen] = useState(false);
  const [
    waitToApproveRegistrationList,
    setWaitToApproveRegistrationList,
  ] = useState<GetRegisteredSalesToApproveResponse[]>([]);
  const [settlementTypes, setSettlementTypes] = useState<GetEnumsResponse[]>();
  const [saleKeys, setSaleKeys] = useState<string[]>([]);
  const [paginationInfo, setPaginationInfo] = useState<PageInfoModel>();
  const [filterObject, setFilterObject] = useState<
    SettlemetRequestToApproveFilter
  >();
  const [allStoresAndBranches, setAllStoresAndBranches] = useState<
    AllStoresAndBranchesResponse[]
  >();
  const [branchesOptions, setBranchesOptions] = useState<GetEnumsResponse[]>();
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = {} as PaginationInfo;
      paginationInfo.pageNumber = 1;
      paginationInfo.pageSize = 10;
      return paginationInfo;
    }
  );
  const [showFilter, setShowFilter] = useState(true);
  const history = useHistory<{
    settlementData?: {
      saleKey: string;
      key?: string;
      branchId?: number;
      customerPersonId?: number;
    };
  }>();
  const queryClient = useQueryClient();

  const addToList = (row: GetRegisteredSalesToApproveResponse) => {
    if (!saleKeys.includes(row.saleKey)) {
      setTotalAmount(totalAmount + row.settlementAmount);
      setSaleKeys([...saleKeys, row.saleKey]);
    } else {
      toast.error("این مورد قبلا انتخاب شده است");
    }
  };
  const removeFromList = (row: GetRegisteredSalesToApproveResponse) => {
    setTotalAmount(totalAmount - row.settlementAmount);
    setSaleKeys(saleKeys.filter((key) => key !== row.saleKey));
  };
  const addAllToList = () => {
    setTotalAmount(
      waitToApproveRegistrationList.reduce(
        (sum, item) => sum + item.settlementAmount,
        0
      )
    );
    const selectedList = queryClient.getQueryData<
      GetRegisteredSalesToApproveResponse[]
    >(SETTLEMENT_REQUEST_KEY);

    setSaleKeys(selectedList!.map((item) => item.saleKey));
  };
  const removeAllFromList = () => {
    setTotalAmount(0);
    setSaleKeys([]);
    queryClient.setQueryData<GetRegisteredSalesToApproveResponse[]>(
      SETTLEMENT_REQUEST_KEY,
      []
    );
    GetRegisteredSalesToApproveMutate({
      filter: filterObject,
      paginationInfo: currentPaginationInfo,
    });
  };

  // services
  const {
    mutate: GetRegisteredSalesToApproveMutate,
    isLoading: tableLoading,
  } = useMutation(getRegisteredSalesToApprove, {
    onSuccess: (
      data: ApiResultModel<GetRegisteredSalesToApproveResponse[]>
    ) => {
      if (data) {
        let selectedDataCache = queryClient.getQueryData<
          GetRegisteredSalesToApproveResponse[]
        >(SETTLEMENT_REQUEST_KEY);
        const filteredData = selectedDataCache
          ? data.data.filter(
              (item) =>
                !selectedDataCache!.some(
                  (selected) => selected.saleKey === item.saleKey
                )
            )
          : data.data;
        setWaitToApproveRegistrationList(filteredData);
        setPaginationInfo(data.pageInfo);
      }
    },
    onError: () => {},
  });
  const { mutate: getAllBranchesMutate } = useMutation(getAllBranches, {
    onSuccess: (data: GetEnumsResponse[]) => {
      if (data) {
        setBranchesOptions(data);
      }
    },
    onError: () => {},
  });
  const { mutate: GetAllStoresAndBranchesMutate } = useMutation(
    GetAllStoresAndBranches,
    {
      onSuccess: (data: AllStoresAndBranchesResponse[]) => {
        if (data) {
          setAllStoresAndBranches(data);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: getEnumsPersianMutate } = useMutation(getEnumsPersian, {
    onSuccess: (data: GetEnumsResponse[]) => {
      if (data) {
        setSettlementTypes(data);
      }
    },
    onError: () => {},
  });
  const { mutate: RegisterSettlementRequestMutate } = useMutation(
    registerSettlementRequest,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          history.push({
            pathname: "/SettelmentWithStoresList",
          });
        }
      },
      onError: () => {},
    }
  );
  const { mutate: getRegisteredSalesToApproveReportExcelMutate } = useMutation(
    getRegisteredSalesToApproveReportExcel,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    }
  );

  // call services

  useEffect(() => {
    GetRegisteredSalesToApproveMutate({
      filter: filterObject,
      paginationInfo: currentPaginationInfo,
    });
  }, [filterObject, currentPaginationInfo]);

  useEffect(() => {
    getEnumsPersianMutate({
      enumNames: ["SettlementType"],
    });
    getAllBranchesMutate({});
    GetAllStoresAndBranchesMutate({});
  }, []);

  // handles
  const handleConfirm = (
    description: string,
    settlementType: SettlementType
  ) => {
    RegisterSettlementRequestMutate({
      description,
      saleKeys: saleKeys!,
      settlementType,
    });
  };

  const handleExportExcel = () => {
    getRegisteredSalesToApproveReportExcelMutate({
      ...filterObject,
    });
  };

  const handleRowClick = (key: string) => {
    const newWindow = window.open("/#/StoreRequestDetail", "_blank");
    newWindow?.sessionStorage.setItem(
      "SETTLEMENT_REQUEST_DATA",
      JSON.stringify({ saleKey: key })
    );
    newWindow?.history.pushState(
      {
        settlementData: { saleKey: key },
      },
      "",
      "/StoreRequestDetail"
    );
  };

  return (
    <>
      <Grid
        container
        flexDirection={"column"}
        flexWrap={"unset"}
        height={"85vh"}
      >
        <Grid
          item
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Tooltip title="فیلتر" arrow>
              <img
                onClick={() => setShowFilter((prev) => !prev)}
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/filter.png"
                alt=""
              />
            </Tooltip>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <Tooltip title="خروجی اکسل" arrow>
              <img
                onClick={handleExportExcel}
                className="cursorPointer"
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/ExportXLS.svg"
                alt="ExportXLS"
              />
            </Tooltip>
          </Box>
        </Grid>

        {showFilter && (
          <Grid
            item
            sx={{
              marginBottom: "10px",
              // height: "20%",
            }}
          >
            <SettlementRequestsListFilter
              setFilterObject={setFilterObject}
              branchesOptions={allStoresAndBranches!}
              filterObject={filterObject!}
              setCurrentPaginationInfo={setCurrentPaginationInfo}
            />
          </Grid>
        )}

        {!tableLoading ? (
          <>
            <Grid item>
              <SelectTable
                listData={waitToApproveRegistrationList}
                columns={columns}
                addToList={addToList}
                removeFromList={removeFromList}
                addAllToList={addAllToList}
                removeAllFromList={removeAllFromList}
                paginationInfo={paginationInfo!}
                currentPaginationInfo={currentPaginationInfo}
                setCurrentPaginationInfo={setCurrentPaginationInfo}
                handleRowClick={handleRowClick}
              />
            </Grid>
            <Grid
              item
              container
              xs={12}
              sx={{
                display: "flex",
                alignItems: "end",
                marginTop: "10px",
              }}
              justifyContent={{ xs: "space-between", md: "end" }}
            >
              <Grid item marginLeft="5px">
                <Box
                  sx={{
                    background: "#F9FAFC",
                    borderRadius: "5px",
                    border: "1px solid #DAE0E4",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px",
                    // gap: "15rem",
                  }}
                  gap={{ xs: "5rem", md: "15rem" }}
                >
                  <Typography sx={{ color: "#1D4A87", fontSize: "1rem" }}>
                    جمع کل (ریال):
                  </Typography>
                  <Typography
                    sx={{
                      color: "#1D4A87",
                      fontSize: "1rem",
                      fontWeight: "bold",
                    }}
                  >
                    {totalAmount.toLocaleString("fa")}
                  </Typography>
                </Box>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  disabled={totalAmount === 0}
                  fullWidth
                  className={
                    totalAmount === 0
                      ? "btnForm disabledBtn"
                      : "btnForm SuccessDefault"
                  }
                  sx={{ maxWidth: "160px" }}
                  onClick={() => setOpen(true)}
                >
                  ثبت اولیه
                </Button>
              </Grid>
            </Grid>
          </>
        ) : (
          <SettlementRequestsListSkeleton />
        )}
      </Grid>
      <SettelmentRequestListModal
        open={open}
        setOpen={setOpen}
        amount={totalAmount}
        handleClose={() => setOpen(false)}
        settlementTypes={settlementTypes!}
        handleConfirm={handleConfirm}
      />
    </>
  );
};

export default SettelmentRequestsList;
